export const maxHeight = '800px';
export const maxValueScale = 1.2;

export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
